"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultDescriptionConfig = exports.defaultTitleConfig = exports.defaultLabelConfig = void 0;
var defaultLabelConfig = {
    size: 6,
    textDecoration: 'underline',
    margin: {
        desktop: '0 0 10px',
        tablet: '0 0 10px',
        mobile: '0 0 10px'
    }
};
exports.defaultLabelConfig = defaultLabelConfig;
var defaultTitleConfig = {
    size: 1,
    lineHeight: 1.1,
    margin: {
        desktop: '0 0 20px',
        tablet: '0 0 20px',
        mobile: '0 0 20px'
    }
};
exports.defaultTitleConfig = defaultTitleConfig;
var defaultDescriptionConfig = {
    align: 'center'
};
exports.defaultDescriptionConfig = defaultDescriptionConfig;
//# sourceMappingURL=Headline.js.map